/**
 * Detects the "account deactivated" response the API Gateway returns once an
 * admin blocks the account (HTTP 403 with error_code "ACCOUNT_DEACTIVATED").
 *
 * When detected it dispatches a global `account-deactivated` window event
 * (once) so the app-wide <AccountDeactivatedModal> can show a blocking modal.
 * The modal's button is what actually clears the session and navigates to the
 * login page — we intentionally do NOT redirect here so the modal stays in
 * control. Returns true when it handled a deactivation (so callers can stop
 * further processing).
 */
export const ACCOUNT_DEACTIVATED_EVENT = "account-deactivated";

let alreadyHandled = false;

export const handleAccountDeactivated = (error) => {
  const res = error?.response;
  const code = res?.data?.error_code || res?.data?.errorCode;
  if (res?.status === 403 && code === "ACCOUNT_DEACTIVATED") {
    if (!alreadyHandled) {
      alreadyHandled = true;
      try {
        window.dispatchEvent(new CustomEvent(ACCOUNT_DEACTIVATED_EVENT));
      } catch (e) {
        // As a fallback (very old browsers), clear + redirect directly.
        try {
          sessionStorage.clear();
        } catch (err) {
          // ignore
        }
        if (window.location.pathname !== "/") {
          window.location.replace("/");
        }
      }
    }
    return true;
  }
  return false;
};
